import type { FC } from 'react';
import { Select, Group } from '@mantine/core';

interface Agent {
    id: string;
    idn: string;
}

interface Flow {
    id: string;
    idn: string;
}

interface ProjectOption {
    id: string;
    idn: string;
    title: string;
}

interface SearchFiltersProps {
    projects?: ProjectOption[];
    agents?: Agent[];
    flows?: Flow[];
    selectedProject?: string;
    selectedAgent?: string;
    selectedFlow?: string;
    isLoading?: boolean;
    onProjectChange: (value: string | null) => void;
    onAgentChange: (value: string | null) => void;
    onFlowChange: (value: string | null) => void;
}

const SearchFilters: FC<SearchFiltersProps> = ({
    projects,
    agents,
    flows,
    selectedProject,
    selectedAgent,
    selectedFlow,
    isLoading = false,
    onProjectChange,
    onAgentChange,
    onFlowChange
}) => {
    const projectOptions =
        projects?.map((project) => ({
            value: project.id,
            label: project.idn
        })) ?? [];

    const agentOptions =
        agents?.map((agent) => ({
            value: agent.id,
            label: agent.idn
        })) ?? [];

    const flowOptions =
        flows?.map((flow) => ({
            value: flow.id,
            label: flow.idn
        })) ?? [];

    const validSelectedAgent =
        selectedAgent && agentOptions.some((opt) => opt.value === selectedAgent)
            ? selectedAgent
            : undefined;

    const validSelectedFlow =
        selectedFlow && flowOptions.some((opt) => opt.value === selectedFlow)
            ? selectedFlow
            : undefined;

    return (
        <Group grow wrap="nowrap">
            <Select
                clearable
                searchable
                data={projectOptions}
                disabled={isLoading}
                label="Project"
                placeholder="All"
                value={selectedProject ?? undefined}
                onChange={onProjectChange}
            />
            <Select
                clearable
                searchable
                data={agentOptions}
                disabled={!selectedProject || isLoading}
                key={`agent-${selectedProject ?? 'none'}`}
                label="Agent"
                placeholder="All"
                value={validSelectedAgent}
                onChange={onAgentChange}
            />
            <Select
                clearable
                searchable
                data={flowOptions}
                disabled={!selectedAgent || isLoading}
                key={`flow-${selectedAgent ?? 'none'}`}
                label="Flow"
                placeholder="All"
                value={validSelectedFlow}
                onChange={onFlowChange}
            />
        </Group>
    );
};

export default SearchFilters;
